// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_status__xlUqT {
  color: #ffc107;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--rs_yellow_10, #fff9e7);
  white-space: pre;
}

.style_new__u2kqz {
  color: #757575;
  background: #f5f5f5;
}

.style_inProgress__-h0-3 {
  color: #ffc107;
  background: #fff9e7;
}

.style_contacted__yLCv7 {
  color: #220d77;
  background: #e9e7f2;
}

.style_hired__rsWpB {
  color: #e6f6ec;
  background: #00a43b;
}

.style_rejected__Sa7on {
  color: #fff1ef;
  background: #d84315;
}

.style_spam__xvgMq {
  color: #fff1ef;
  background: lightgray;
}

.style_synced__i0vZJ {
  color: #00a43b;
  background: #e6f6ec;
}

.style_TasksTable__Bac\\+O,
.style_nameAndLogo__X8ubi {
  display: flex;
  align-items: center;
}
.style_TasksTable__Bac\\+O p,
.style_nameAndLogo__X8ubi p {
  margin: 0;
}
.style_TasksTable__Bac\\+O img,
.style_nameAndLogo__X8ubi img {
  margin-right: 10px;
  border-radius: 5px;
}
.style_TasksTable__Bac\\+O .style_nameAndLogo__X8ubi p,
.style_TasksTable__Bac\\+O .style_jobType__9cfhb p,
.style_nameAndLogo__X8ubi .style_nameAndLogo__X8ubi p,
.style_nameAndLogo__X8ubi .style_jobType__9cfhb p {
  margin: 0;
}
.style_TasksTable__Bac\\+O .style_image-card__kCDG1 img,
.style_nameAndLogo__X8ubi .style_image-card__kCDG1 img {
  border-radius: 10px;
}
.style_TasksTable__Bac\\+O .style_showFilesInvoice__UKXe7,
.style_nameAndLogo__X8ubi .style_showFilesInvoice__UKXe7 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
.style_TasksTable__Bac\\+O .style_fileCont__Nz0SK,
.style_nameAndLogo__X8ubi .style_fileCont__Nz0SK {
  position: relative;
}
.style_TasksTable__Bac\\+O .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__ztNlA,
.style_nameAndLogo__X8ubi .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__ztNlA {
  align-items: baseline;
}
.style_TasksTable__Bac\\+O .style_statusOrders__1Ox6i,
.style_nameAndLogo__X8ubi .style_statusOrders__1Ox6i {
  display: flex;
  align-items: center;
}
.style_TasksTable__Bac\\+O .style_statusOrders__1Ox6i .style_space__5zEZG,
.style_nameAndLogo__X8ubi .style_statusOrders__1Ox6i .style_space__5zEZG {
  margin-right: 5px;
}

.style_EnhancedTableToolbar__jVCLS .style_sortAndFilters__Yxdwm {
  display: flex;
  justify-content: flex-end;
}

.style_filterDrawer__jN--K .style_drawerContainer__LaWrR {
  width: 20vw;
  min-width: 230px;
  margin-top: 60%;
}
.style_filterDrawer__jN--K .style_drawerContainer__LaWrR .style_header__J3ayL {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_filterDrawer__jN--K .style_drawerContainer__LaWrR form > div {
  margin-top: 20px;
}
.style_filterDrawer__jN--K .style_drawerContainer__LaWrR .style_clearButt__P5o1x {
  margin-top: 20px;
  height: 3.5em;
}

@media (max-width: 768px) {
  * {
    font-size: 10px;
  }
}
.style_sortby__bxN8W {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: fit-content;
  text-align: center;
  border-right: solid rgba(161, 158, 158, 0.5) 1px;
  border-left: solid rgba(161, 158, 158, 0.5) 1px;
}
.style_sortby__bxN8W label {
  margin-right: 10px;
  margin-left: 10px;
}
.style_sortby__bxN8W .style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__6M3p3:before {
  border-bottom: none;
}
.style_sortby__bxN8W #style_demo-simple-select__gqQQA {
  margin-top: 3px;
}

.style_removeIcon__OvSep {
  cursor: pointer;
  transition: transform 0.2s;
}
.style_removeIcon__OvSep:hover {
  transform: scale(1.2);
}
.style_removeIcon__OvSep:active {
  transform: scale(0.9);
}

.style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__PAKF-:before {
  border-bottom: none;
}

.style_searchBy__uYqNZ {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/views/AccountsAndPermissions/Accounts/ExternalUsers/table/RowRender/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAIA;EACE,cAAA;EACA,qBAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;AADF;;AAUA;;EAEE,aAAA;EACA,mBAAA;AAPF;AAQE;;EACE,SAAA;AALJ;AAOE;;EACE,kBAAA;EACA,kBAAA;AAJJ;AASI;;;;EACE,SAAA;AAJN;AAQE;;EACE,mBAAA;AALJ;AAQE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AALJ;AAQE;;EACE,kBAAA;AALJ;AAQE;;EACE,qBAAA;AALJ;AAQE;;EACE,aAAA;EACA,mBAAA;AALJ;AAMI;;EACE,iBAAA;AAHN;;AASE;EACE,aAAA;EACA,yBAAA;AANJ;;AAWE;EAME,WAAA;EACA,gBAAA;EACA,eAAA;AAbJ;AAMI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJN;AASI;EACE,gBAAA;AAPN;AASI;EACE,gBAAA;EACA,aAAA;AAPN;;AAYA;EACE;IACE,eAAA;EATF;AACF;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gDA9FW;EA+FX,+CA/FW;AAoFb;AAaE;EACE,kBAAA;EACA,iBAAA;AAXJ;AAaE;EACE,mBAAA;AAXJ;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,eAAA;EACA,0BAAA;AAZF;AAaE;EACE,qBAAA;AAXJ;AAaE;EACE,qBAAA;AAXJ;;AAeA;EACE,mBAAA;AAZF;;AAcA;EACE,iBAAA;AAXF","sourcesContent":[".status {\n  color: #ffc107;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0px;\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  background: var(--rs_yellow_10, #fff9e7);\n  white-space: pre;\n}\n\n.chanelChip {\n}\n\n.new {\n  color: #757575;\n  background: #f5f5f5;\n}\n\n.inProgress {\n  color: #ffc107;\n  background: #fff9e7;\n}\n\n.contacted {\n  color: #220d77;\n  background: #e9e7f2;\n}\n\n.hired {\n  color: #e6f6ec;\n  background: #00a43b;\n}\n\n.rejected {\n  color: #fff1ef;\n  background: #d84315;\n}\n.spam {\n  color: #fff1ef;\n  background: lightgray;\n}\n\n.synced {\n  color: #00a43b;\n  background: #e6f6ec;\n}\n\n$borderSide: solid\n  rgba(\n    $color: #a19e9e,\n    $alpha: 0.5,\n  )\n  1px;\n.TasksTable,\n.nameAndLogo {\n  display: flex;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n  img {\n    margin-right: 10px;\n    border-radius: 5px;\n  }\n\n  .nameAndLogo,\n  .jobType {\n    p {\n      margin: 0;\n    }\n  }\n\n  .image-card img {\n    border-radius: 10px;\n  }\n\n  .showFilesInvoice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 5%;\n  }\n\n  .fileCont {\n    position: relative;\n  }\n\n  .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {\n    align-items: baseline;\n  }\n\n  .statusOrders {\n    display: flex;\n    align-items: center;\n    .space {\n      margin-right: 5px;\n    }\n  }\n}\n\n.EnhancedTableToolbar {\n  .sortAndFilters {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.filterDrawer {\n  .drawerContainer {\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    width: 20vw;\n    min-width: 230px;\n    margin-top: 60%;\n    form > div {\n      margin-top: 20px;\n    }\n    .clearButt {\n      margin-top: 20px;\n      height: 3.5em;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  * {\n    font-size: 10px;\n  }\n}\n.sortby {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 5px;\n  width: fit-content;\n  text-align: center;\n\n  border-right: $borderSide;\n  border-left: $borderSide;\n\n  label {\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n  .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n    border-bottom: none;\n  }\n  #demo-simple-select {\n    margin-top: 3px;\n  }\n}\n\n.removeIcon {\n  cursor: pointer;\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.2);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border-bottom: none;\n}\n.searchBy {\n  border-left: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `style_status__xlUqT`,
	"new": `style_new__u2kqz`,
	"inProgress": `style_inProgress__-h0-3`,
	"contacted": `style_contacted__yLCv7`,
	"hired": `style_hired__rsWpB`,
	"rejected": `style_rejected__Sa7on`,
	"spam": `style_spam__xvgMq`,
	"synced": `style_synced__i0vZJ`,
	"TasksTable": `style_TasksTable__Bac+O`,
	"nameAndLogo": `style_nameAndLogo__X8ubi`,
	"jobType": `style_jobType__9cfhb`,
	"image-card": `style_image-card__kCDG1`,
	"showFilesInvoice": `style_showFilesInvoice__UKXe7`,
	"fileCont": `style_fileCont__Nz0SK`,
	"css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar": `style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__ztNlA`,
	"statusOrders": `style_statusOrders__1Ox6i`,
	"space": `style_space__5zEZG`,
	"EnhancedTableToolbar": `style_EnhancedTableToolbar__jVCLS`,
	"sortAndFilters": `style_sortAndFilters__Yxdwm`,
	"filterDrawer": `style_filterDrawer__jN--K`,
	"drawerContainer": `style_drawerContainer__LaWrR`,
	"header": `style_header__J3ayL`,
	"clearButt": `style_clearButt__P5o1x`,
	"sortby": `style_sortby__bxN8W`,
	"css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__6M3p3`,
	"demo-simple-select": `style_demo-simple-select__gqQQA`,
	"removeIcon": `style_removeIcon__OvSep`,
	"css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__PAKF-`,
	"searchBy": `style_searchBy__uYqNZ`
};
export default ___CSS_LOADER_EXPORT___;
